import React from 'react';
interface TimelineEventProps {
  title: string;
  children: ReactNode;
}
const TimelineEvent = ({
  title,
  children
}: TimelineEventProps) => {
  return <div className="relative pl-8 mb-10" data-id="element-18244" data-mp="32hd36cbyil81">
      <div className="absolute left-0 top-2 w-5 h-5 rounded-full bg-gray-800 -ml-2 border-2 border-white" data-id="element-18245" data-mp="37i0qoo0z8jxi"></div>
      <h3 className="text-xl font-serif font-bold text-gray-800 mb-3 border-b border-gray-200 pb-2" data-id="element-18246" data-mp="3c9iwbpdy38ot">
        {title}
      </h3>
      <div className="bg-gray-50 p-5 rounded-lg border border-gray-300 shadow-sm" data-id="element-18247" data-mp="3gacjuhnh6lh6">
        {children}
      </div>
    </div>;
};
export default TimelineEvent;